import { render, staticRenderFns } from "./ContactDM2Modal.vue?vue&type=template&id=6c789cbf&scoped=true&"
import script from "./ContactDM2Modal.vue?vue&type=script&lang=js&"
export * from "./ContactDM2Modal.vue?vue&type=script&lang=js&"
import style0 from "./ContactDM2Modal.vue?vue&type=style&index=0&id=6c789cbf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c789cbf",
  null
  
)

export default component.exports